import * as Sentry from '@sentry/angular';
import { APP_INITIALIZER, ErrorHandler, Provider } from '@angular/core';
import { Router } from '@angular/router';

export const SentryInitializerProvider: Provider[] = [
    {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler()
    },
    {
        provide: Sentry.TraceService,
        deps: [Router]
    },
    {
        provide: APP_INITIALIZER,
        useFactory: () => () => {
            return Promise.resolve();
        },
        deps: [Sentry.TraceService],
        multi: true
    }
];
